// @flow
import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from '../MapMarker';

import type { Venue, VenueMapProps } from '../types';

const VenueMap = (props: VenueMapProps) => {
  const mapRef = React.useRef();
  const [isMounted, setIsMounted] = React.useState(false);
  if (
    Array.from(document.querySelectorAll('.gm-control-active')).reduce(
      (acc, el) => {
        if (el.attributes.title.value.toLowerCase().includes('zoom'))
          acc.push(el);
        return acc;
      },
      [],
    ).length > 0 &&
    !isMounted
  )
    setIsMounted(true);

  React.useEffect(() => {
    const zoomControls = Array.from(
      document.querySelectorAll('.gm-control-active'),
    ).reduce((acc, el) => {
      if (el.attributes.title.value.toLowerCase().includes('zoom'))
        acc.push(el);
      return acc;
    }, []);
    zoomControls.forEach(ctrl => {
      if (ctrl.attributes.title.value.toLowerCase().includes('in')) {
        ctrl.addEventListener('click', function() {
          props.onZoomChange(1);
        });
      } else
        ctrl.addEventListener('click', function() {
          props.onZoomChange(-1);
        });
    });
    return () => {
      zoomControls.forEach(ctrl => {
        ctrl.removeEventListener('click', null);
      });
    };
  }, [isMounted]);

  return (
    <div style={{ height: '70vh', width: '100%' }}>
      <div id="map" style={{ position: 'relative', top: '-5rem' }} />
      <GoogleMapReact
        ref={mapRef}
        center={props.center}
        zoom={props.zoom}
        onDragEnd={props.onDragEnd}
        bootstrapURLKeys={{ key: 'AIzaSyDQyYv_Rv0Smp2pupR1y2pIaaD_aAVoFAw' }}
        options={{
          zoomControl: true,
          fullscreenControl: false,
          minZoom: 3,
        }}
      >
        {props.venues &&
          props.venues.map((el: Venue) => (
            <MapMarker
              lat={el.latitude}
              lng={el.longitude}
              venue={el}
              key={`${el.latitude},${el.longitude}`}
              onMarkerClick={props.onMarkerClick}
            />
          ))}
      </GoogleMapReact>
    </div>
  );
};

VenueMap.defaultProps = {
  center: {
    lat: 39,
    lng: -77,
  },
  zoom: 6,
};

export default VenueMap;
